import config from '../config';
import { setAttachments, actionDeleteAttachment } from '../actions/attachments';  
import fetch2 from 'cross-fetch';
import store from 'store2';
import { addNotification as notify } from 'reapop';
import { push } from 'react-router-redux';

export const ATTACHMENT_TASK = '';
export const ATTACHMENT_EMPLOYEE = 'employee';


function getUrlSufixByType(type) {
    return type === ATTACHMENT_TASK ? '' : '?reference=' + type;
}

export function getAttachmentsById(id, type) {
    return (dispatch) => {
      const userAuth = store.get('user');
      if (userAuth && userAuth.api_token) {
        return fetch2(`${config.apiEndpoint}/attachments/getAttachments/${id}${getUrlSufixByType(type)}`, {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `bearer ${userAuth.api_token}`
            },
            credentials: 'same-origin'
          })
          .then((response) => {
            return response.json();
          })
          .then(json => {
            if (json) {
              dispatch(setAttachments({ currentAttachments: json }));
            }
          })
      }
    }
  }

  export function deleteAttachmentById(id, type) {
    return (dispatch) => {
      const userAuth = store.get('user');
      if (userAuth && userAuth.api_token) {
        return fetch2(`${config.apiEndpoint}/attachments/${id}${getUrlSufixByType(type)}`, {
            method: 'DELETE',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `bearer ${userAuth.api_token}`
            },
            credentials: 'same-origin'
          })
          .then((response) => {
            return response.json();
          })
          .then(json => {
            if (json) {
              dispatch(notify({
                title: 'Delete Attachment',
                message: 'Attachment deleted successfully',
                status: 'success',
                position: 'tr',
                dismissible: true,
                dismissAfter: 3000
              }));
              dispatch(actionDeleteAttachment({ deleteAttachment: id }));
            } else {
              dispatch(notify({
                title: 'Delete Attachment',
                message: 'Failed to delete attachment',
                status: 'error',
                position: 'tr',
                dismissible: true,
                dismissAfter: 3000
              }));
            }
          })
      }
    }
  };

  export function uploadAttachmentData(id, type, formData, qc) {
    return (dispatch) => {
      const userAuth = store.get('user');
      if (userAuth && userAuth.api_token) {
        if(qc) formData.append('type', 1);
        return fetch2(`${config.apiEndpoint}/attachments/${id}${getUrlSufixByType(type)}`, {
            method: 'POST',
            headers: {
              'Authorization': `bearer ${userAuth.api_token}`
            },
            credentials: 'same-origin',
            body: formData,
          })
          .then((response) => {
            return response.json();
          })
          .then(json => {
            if (json) {
              dispatch(notify({
                title: 'Upload Attachment',
                message: 'Attachment uploaded successfully',
                status: 'success',
                position: 'tr',
                dismissible: true,
                dismissAfter: 3000
              }));
              dispatch(getAttachmentsById(id, type));
            } else {
              dispatch(notify({
                title: 'Upload Attachment',
                message: 'Failed to upload attachment',
                status: 'error',
                position: 'tr',
                dismissible: true,
                dismissAfter: 3000
              }));
            }
          })
      }
    }
  };


// WEBPACK FOOTER //
// ./src/api/attachments.js